// Mobile native pickers ignore CSS on <option>/<optgroup>, so filtering must
// physically remove non-matching optgroups from the DOM instead of hiding them.
// The full optgroup set is cached on the select the first time it is filtered.
// Returns true when the current selection no longer matched and was reset.
function filterOptgroups($select, keep){
  if(!$select.length) return false;

  const selected = $select.val();

  let allGroups = $select.data('allOptgroups');
  if(allGroups){
    $select.find('optgroup').detach();
  } else {
    allGroups = $select.find('optgroup').detach();
    $select.data('allOptgroups', allGroups);
  }

  allGroups.each(function(){
    if(keep($(this))) $select.append(this);
  });

  $select.val(selected);
  if($select.val() !== null) return false;

  $select.prop('selectedIndex', 0);
  return true;
}

window.adaptResidenceFilters = function(){
  const country = $('.js-country').val();

  const cityReset = filterOptgroups($('.js-city'), function($group){
    return !country || $group.attr('data-country') === country;
  });

  const city = $('.js-city').val();

  const areaReset = filterOptgroups($('.js-area'), function($group){
    return (!country || $group.attr('data-country') === country) &&
           (!city || $group.attr('data-city') === city);
  });

  // A reset selection was already submitted with the stale value, so re-trigger
  // the filters once. Native event, because initFilters binds via addEventListener.
  if(cityReset || areaReset){
    const select = $('.js-city')[0] || $('.js-area')[0];
    if(select) select.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
